import React from "react";

export const TotalCTC = ({ amount, salaryType }) => {
  const formattedAmount = new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);

  return (
    <div className="bg-[#F4F5F9] sticky bottom-0 border border-gray-200 w-full">
      <div className="px-6 py-4 flex justify-between items-center">
        <h2 className="text-md font-medium text-[#3A3541]">
          Total CTC :-
        </h2>
        <div className="text-md font-medium text-[#3A3541]">
          ₹ {formattedAmount}/
          <span className="text-[#3A3541]">{salaryType}</span>
        </div>
      </div>
    </div>
  );
};